<template>
  <common-panel
    class="new-training-center"
    :ifShowTitle="false"
    paddingTopVal="10px"
  >
    <a-tabs :activeKey='activeKey' @change="change" :animated="false">
      <a-tab-pane tab="学习中心" key='0' v-if="collegeList && collegeList.length > 0">
        <div class="college">
          <template v-for="(cVal, cIndex) in collegeList">
            <div class="college-item" :key="'college' +cIndex " @click="goTrainingDetail(cVal.id)">
              <img :src="cVal.courseCoverUrl" alt="">
              <div class="content">
                <span class="name">{{cVal.courseName}}</span>
                <span class="keyword">{{cVal.courseKeywords}}</span>
              </div>
            </div>
          </template>
        </div>
      </a-tab-pane>
      <a-tab-pane tab="常见问题" key='1' v-if="questionList && questionList.length > 0">
        <div class="promotion-tools">
          <template v-for="(qVal, qIndex) in questionList">
            <div class="tools-item" :key="'tools' +qIndex " @click="goTrainingDetail(qVal.id, '138')">
              <span class="circle"></span>
              <span class="title">{{qVal.courseName}}</span>
            </div>
          </template>
        </div>
      </a-tab-pane>
       <a-tab-pane tab="工具教程" key='2' v-if="toolList && toolList.length > 0">
        <div class="promotion-tools">
          <template v-for="(tVal, tIndex) in toolList">
            <div class="tools-item" :key="'tools' +tIndex " @click="goTrainingDetail(tVal.id, '139')">
              <span class="circle"></span>
              <span class="title">{{tVal.courseName}}</span>
            </div>
          </template>
        </div>
      </a-tab-pane>
    </a-tabs>
    <span class="see-more" @click="goMoreTraining"
    v-if="(activeKey == 0 && collegeTotal > 5) || (activeKey == 1 && questionTotal > 10) || (activeKey == 1 && toolTotal > 10)"
    >查看更多></span>
  </common-panel>
</template>

<script>
  import { mapState } from 'vuex'
  import CommonPanel from "@/components/common-panel/index"
  import { Tabs } from 'ant-design-vue'
  import _ from 'lodash'
  const { TabPane } = Tabs
  export default {
    name: "new-training-center",
    components: {
      CommonPanel,
      [Tabs.name]: Tabs,
      [TabPane.name]: TabPane
    },
    data() {
      return {
        collegeList: [],
        collegeTotal:0,
        questionList:[],
        questionTotal:0,
        toolList:[],
        toolTotal:0,
        activeKey:'0',
        collegeSign:'c8556754260e4a5f9131b886697fa460',
        collegeBizType:1,
        promotionSign: '7876e68131ea45478de8d23b475bc462',
        promotionType:4
      }
    },
    mounted () {
      this.queryCourseList('college', 5)
      this.queryCourseList('question', 10, this.treeData.filter(v => v.title === '常见问题')[0].id)
      this.queryCourseList('tool', 10, this.treeData.filter(v => v.title === '工具教程')[0].id)
    },
    computed: {
      ...mapState(['treeData'])
    },
    methods: {
      // 切换面板时调用
      change(activeKey) {
        this.activeKey = activeKey
      },
      // 查询课程列表
      async queryCourseList(type, limit, linkCargoryId = '') {
        let params = {
          page:1,
          limit,
          'pojo.bizType':type === 'college' ? this.collegeBizType : this.promotionType, //业务类型
          'pojo.directedBusinessType':1, // 商家类型
          sign: type === 'college' ? this.collegeSign : this.promotionSign
        }
        linkCargoryId && (params['pojo.linkCargoryId'] = linkCargoryId)
        let collegeRes = await this.$store.dispatch('popHome/queryCourseList',params)
        if (type === 'college') {
          this.collegeList = _.get(collegeRes, ['data'])
          this.collegeTotal = _.get(collegeRes, ['count'])
        } else if (type === 'question') {
          this.questionList = _.get(collegeRes, ['data'])
          this.questionTotal = _.get(collegeRes, ['count'])
        } else {
          this.toolList = _.get(collegeRes, ['data'])
          this.toolTotal = _.get(collegeRes, ['count'])
        }

      },
      // 跳转更多
      goMoreTraining () {
        if (this.activeKey == 0) {
          window.open(`//school.haiziwang.com/`)
        } else {
          window.open(`//open.haiziwang.com/platform?link=${process.env.VUE_APP_SEVERENV === 'BETA' ? 'http' : 'https'}://myseller.haiziwang.com/promotion-tools/publicmore/4/${this.promotionSign}/${this.activeKey == '1' ? '138' : '139'}/1`)
        }
      },
      // 跳转详情
      goTrainingDetail (id, linkCargoryId) {
        if (!id) return
        if (this.activeKey == 0) {
          window.open(`//school.haiziwang.com/detail?id=${id}`)
        } else {
          window.open(`//open.haiziwang.com/platform?link=${process.env.VUE_APP_SEVERENV === 'BETA' ? 'http' : 'https'}://myseller.haiziwang.com/promotion-tools/coursedetail/${id}/${this.promotionSign}/${linkCargoryId}`)
        }
      }
    }
  }
</script>

<style lang="scss">
.ant-tabs-nav-wrap {
  .ant-tabs-nav {
    .ant-tabs-tab-active {
      color: #333333;
      font-weight: bold;
    }
    .ant-tabs-tab:hover {
      color: #333333;
      font-weight: bold;
    }
  }
}
</style>

<style lang="scss" scoped>
.new-training-center {
  position: relative;
}
.college {
  display: flex;
  flex-direction: column;
  .college-item {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    cursor: pointer;
    img {
      width: 80px;
      height: 60px;
      flex-shrink: 0;
      margin-right: 10px;
    }
    .content {
      display: flex;
      flex-direction: column;
      .name {
        font-family: MicrosoftYaHei-Bold;
        font-weight: bold;
        font-size: 14px;
        color: #333333;
        letter-spacing: 0;
        margin-bottom: 10px;
      }
      .keyword {
        font-family: MicrosoftYaHei;
        font-size: 13px;
        color: #666666;
        letter-spacing: 0;
      }
    }
  }
}
.see-more {
  position: absolute;
  bottom: 20px;
  width: 100%;
  font-family: MicrosoftYaHei;
  font-size: 13px;
  color: #666666;
  letter-spacing: 0;
  display: flex;
  justify-content: center;
  cursor: pointer;
}
.promotion-tools {
  display: flex;
  flex-direction: column;
  .tools-item {
    display: flex;
    margin-bottom: 20px;
    align-items: center;
    cursor: pointer;
    .circle {
      width: 3px;
      height: 3px;
      border-radius: 50%;
      background: #333;
      margin-right: 10px;
    }
    .title {
      font-family: MicrosoftYaHei;
      font-size: 14px;
      color: #333333;
      letter-spacing: 0;
    }
  }
}
</style>
